// src/csv-icon.tsx
import { createSvgIcon } from "@mui/material";
import { jsx } from "react/jsx-runtime";
var CSVIcon = createSvgIcon(
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M19.788 7.2a.736.736 0 0 1 .212.505v.713h-5.79a.729.729 0 0 1-.512-.21.707.707 0 0 1-.212-.503V3.426H5.525v5.068H4.077V3.426c0-.38.155-.741.425-1.008.27-.266.637-.418 1.023-.418h8.685a.75.75 0 0 1 .511.21l5.067 4.99Zm-4.854-2.766v2.558h2.596l-2.596-2.558ZM4 11.56v5.48c0 .856.825 1.56 1.83 1.56H8v-1.203H5.83c-.234 0-.422-.16-.422-.357v-5.48c0-.197.188-.357.422-.357H8V10H5.83C4.825 10 4 10.695 4 11.56Zm8.048 1.767h-1.096c-.337 0-.596-.17-.596-.321v-1.417c0-.152.259-.321.596-.321h2.46v-1.203h-2.46c-1.08 0-1.952.686-1.952 1.524v1.417c0 .838.872 1.524 1.952 1.524h1.096c.337 0 .596.169.596.32v2.29c0 .152-.259.322-.596.322h-2.46v1.203h2.46c1.08 0 1.952-.686 1.952-1.524v-2.29c0-.838-.872-1.524-1.952-1.524Zm5.658 4.057L18.565 10l1.435.107-.996 8.493h-3.008l-.009-.08L15 10.107 16.435 10l.01.08.858 7.304h.403Zm-13.629 2.18v.01-.01Zm0 .01H20c0 .38-.154.741-.425 1.008-.27.266-.636.418-1.023.418H5.525a1.436 1.436 0 0 1-1.448-1.426Z",
      clipRule: "evenodd"
    }
  ),
  "CSVIcon"
);

export {
  CSVIcon
};
